import { api } from "@/store";
import { jwtDecode } from "jwt-decode";

const VOUCHER_KEY = "voucher_token";
const VOUCHER_EXPIRY = "voucher_expiry";

export default {
    async generateVoucher(url = null) {
        url = url || "/vouchers/generate/10-percent";
        const token = localStorage.getItem(VOUCHER_KEY);
        const expiry = localStorage.getItem(VOUCHER_EXPIRY);

        if (token && expiry && new Date(expiry) > new Date()) {
            const decoded = jwtDecode(token);
            return { code: decoded.code, voucher_mode: decoded.voucher_mode, voucher_value: decoded.voucher_value, expiry };
        }

        const res = await api.post(url, {});
        localStorage.setItem(VOUCHER_KEY, res.data.token);
        localStorage.setItem(VOUCHER_EXPIRY, res.data.expiry);

        return { code: res.data.voucher_code, voucher_mode: res.data.voucher_mode, voucher_value: res.data.voucher_value, expiry: res.data.expiry };
    },
    async generateVoucherOld() {
        // Check if voucher exists and is still valid
        const existingToken = localStorage.getItem(VOUCHER_KEY);
        const expiry = localStorage.getItem(VOUCHER_EXPIRY);

        if (existingToken && expiry) {
            const now = new Date();
            if (new Date(expiry) > now) {
                // Still valid → return existing voucher
                const decoded = jwt_decode(existingToken);
                return { code: decoded.code, expiry };
            } else {
                // Expired → clear and allow new generation
                localStorage.removeItem(VOUCHER_KEY);
                localStorage.removeItem(VOUCHER_EXPIRY);
            }
        }

        // Generate new voucher
        const res = await api.post("/voucher/generate", { prefix: "SOCCER", length: 6 });
        localStorage.setItem(VOUCHER_KEY, res.data.token);
        localStorage.setItem(VOUCHER_EXPIRY, res.data.expiry);

        const decoded = jwt_decode(res.data.token);
        return { code: decoded.code, expiry: res.data.expiry };
    },

    getVoucher() {
        const token = localStorage.getItem(VOUCHER_KEY);
        const expiry = localStorage.getItem(VOUCHER_EXPIRY);
        if (!token) return null;
        const decoded = jwtDecode(token);
        return { code: decoded.code, voucher_mode: decoded.voucher_mode, voucher_value: decoded.voucher_value, expiry };
    },

    async syncVoucher(userId) {
        const token = localStorage.getItem(VOUCHER_KEY);
        const expiry = localStorage.getItem(VOUCHER_EXPIRY);
        if (!token) return;
        const now = new Date();
        if (expiry && new Date(expiry) > now) {
            // Still valid → sync voucher in backend
            await api.post("/vouchers/register", {token, expiry });
            // keep in localStorage until redeemed
        }
    },

    redeemVoucher(code) {
        const voucher = this.getVoucher();
        if (code === voucher.code) {
            localStorage.removeItem(VOUCHER_KEY);
            localStorage.removeItem(VOUCHER_EXPIRY);
        }
    }
};
